import { extendObservable, runInAction } from 'mobx';

import { ProductsController } from '../../../networking/controllers/ProductsController';
import { Logger } from '../../../helpers/Logger';
import { ConfigParametersStore } from '../../../stores/ConfigParametersStore';

class CategoryProductsStoreClass {
  constructor() {
    extendObservable(this, {
      products: null,
    });
    this.subMenuId = null;
    this.productTypeId = null;
    // Used to avoid race conditions on products requests.
    this.productsRequestId = 0;
  }

  async fetchProductsForCategory(subMenuId, productTypeId, queryFilter) {
    this.productsRequestId += 1;
    const requestId = this.productsRequestId;
    try {
      if (this.products &&
        (this.subMenuId !== subMenuId || this.productTypeId !== productTypeId)) {
        runInAction(() => {
          this.products = null;
        });
      }
      const products = await ProductsController
        .findByCategory(subMenuId, productTypeId, queryFilter);
      if (requestId !== this.productsRequestId) {
        return;
      }
      runInAction(() => {
        const categoryOrder = ConfigParametersStore.getFeatureFlagData('category_products_order');
        const sortOrder = categoryOrder[subMenuId] && Array.from(categoryOrder[subMenuId].values());

        const mapped = products.map((product) => {
          const productPrice = ConfigParametersStore.isValueInFeatureFlagData('product-price', product.id);

          if (!product.shouldShowPrice() && productPrice) {
            // eslint-disable-next-line no-param-reassign
            product.financing = productPrice;
          }

          return product;
        });

        if (!sortOrder || !sortOrder.length) {
          this.products = mapped;
        } else {
          const orderMap = {};
          for (let i = 0; i < sortOrder.length; i += 1) {
            orderMap[sortOrder[i]] = i;
          }

          this.products = mapped.slice().sort((a, b) => {
            // eslint-disable-next-line no-prototype-builtins
            const ai = orderMap.hasOwnProperty(a.id) ? orderMap[a.id] : Number.POSITIVE_INFINITY;
            // eslint-disable-next-line no-prototype-builtins
            const bi = orderMap.hasOwnProperty(b.id) ? orderMap[b.id] : Number.POSITIVE_INFINITY;
            return ai - bi;
          });
        }
      });
    } catch (error) {
      Logger.warn(error);
    }
  }
}

export const CategoryProductsStore = new CategoryProductsStoreClass();



// WEBPACK FOOTER //
// ./src/pages/product-index/stores/CategoryProductsStore.js